import { Injectable } from "@angular/core";
import { Trainer } from "app/core/models/trainer/trainer.model";
import { Adapter } from "../../adapters";


@Injectable({
    providedIn: "root"
})

export class TrainerAdapter implements Adapter<Trainer> {
   model: Trainer;
    adapt(item: any): Trainer {
        this.model =  new Trainer();    
        this.model.id = item?.id ?? 0,
        this.model.name = item?.name ?? '';
        this.model.email = item?.aud ?? '';
        this.model.mobile = item?.mobile ?? '';
        this.model.token = item?.token ?? '';
        this.model.skybind = item?.rolepermission ?? '';
        this.model.roleId = item?.role_id ?? '';
        this.model.otp = item?.otp ?? '';
        return this.model;
    }
}